import { render, staticRenderFns } from "./OnboardingDomainInstantVerificationModal.vue?vue&type=template&id=5c7d058b&scoped=true"
import script from "./OnboardingDomainInstantVerificationModal.vue?vue&type=script&lang=js"
export * from "./OnboardingDomainInstantVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDomainInstantVerificationModal.vue?vue&type=style&index=0&id=5c7d058b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d058b",
  null
  
)

export default component.exports